export default __webpack_public_path__ + "static/media/element_60.ba75006f.jpg";